import { NavLink } from "react-router-dom";
import { mainNavigation } from "../../config/navigation";
import { appAssets } from "../../config/assets";

export default function AppHeader() {
    return (
        <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0b0f17]/95 backdrop-blur-md">
            <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-4 md:px-6 lg:px-8">
                <div className="flex min-w-0 items-center gap-2 md:gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden sm:h-12 sm:w-12 md:h-14 md:w-14">
                        <img
                            src={appAssets.league.logo}
                            alt="Logo Ligue des 2 Zéros"
                            className="h-full w-full object-contain"
                        />
                    </div>

                    <div className="hidden min-w-0 md:block">
                        <p className="truncate text-lg font-black uppercase tracking-wide text-white md:text-xl">
                            Ligue des 2 Zéros
                        </p>
                        <p className="truncate text-xs font-semibold uppercase tracking-[0.2em] text-white/50">
                            Luxembourg et 3 frontières
                        </p>
                    </div>
                </div>

                <nav className="hidden items-center gap-6 xl:flex">
                    {mainNavigation.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) =>
                                `text-sm font-black uppercase tracking-wide transition ${
                                    isActive
                                        ? "text-[#e5ff00]"
                                        : "text-white hover:text-[#ff7a00]"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <button className="rounded-md border border-white/10 px-3 py-2 text-sm font-bold text-white/80 xl:hidden">
                        Menu
                    </button>
                </div>
            </div>
        </header>
    );
}